import {
    SURVEY_EDITOR_LIKERT_DRAG_AND_DROP
} from "../../../../../constants";


export const likertDragAndDrop = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: SURVEY_EDITOR_LIKERT_DRAG_AND_DROP, payload });
    }
};